import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import $ from 'jquery';
import { TimelineMax, TweenMax, RoughEase, Power0} from 'gsap';

const overflowVisible = {overflow:'visible',opacity:1};

let once = true;

class Wreath extends Component {

  componentDidMount(){
    //   light flicker animation
      let lights = $('.js-light');
      let bulbs = $('.js-bulb');
      let bulbsGreen = $('#bulb__g-fill');
      let bulbsBlue = $('#bulb__b-fill');
      let bulbsRed = $('#bulb__r-fill');
      let bulbsYellow = $('#bulb__y-fill');
      let stars = $('.js-star');
      let bokahLG = $('#bokeh--large use');
      let bokahSM = $('#bokah--small path');

      let stageLight = $('.js-stage-lighting');
      let lightingSwatch = document.getElementsByClassName("stage__lighting-swatch")[0];

      if (once == true && !window.mobile) {

          //   $.each(bulbs, function() {
          //       fadeTween(this, randomIntFromInterval(0.5, 1) * 0.95, 0.35, 0);
          //   });
          // $.each(bulbsGreen, function() {
              fadeTween(bulbsGreen, randomIntFromInterval(0.5, 1) * 0.95, 0.35, 0);
          // });
          // $.each(bulbsBlue, function() {
              fadeTween(bulbsBlue, randomIntFromInterval(0.5, 1) * 0.95, 0.35, 0);
          // });
          // $.each(bulbsRed, function() {
              fadeTween(bulbsRed, randomIntFromInterval(0.5, 1) * 0.95, 0.35, 0);
          // });
          // $.each(bulbsYellow, function() {
              fadeTween(bulbsYellow, randomIntFromInterval(0.5, 1) * 0.95, 0.35, 0);
          // });
            // $.each(lights, function() {
            //     fadeTween(this, randomIntFromInterval(0.5, 1) * 1, 0.35, randomIntFromInterval(0, 1));
            // });
            // $.each(stars, function() {
            //     flicker(this, Math.random() * 0.5 + 0.75, 0.25);
            // });
            $.each(bokahLG, function() {
                fadeTween(this, randomIntFromInterval(0.5, 1) * 1.25, 0.25, 0);
            });
            $.each(bokahSM, function() {
                fadeTween(this, randomIntFromInterval(0.5, 1) * 1.15, 0, 0);
            });

            // window.TweenMax.set(lightingSwatch, {
            //     color: 'rgba(49, 180, 94, 0.3)',
            //     backgroundColor: 'rgba(0, 0, 0, 0.7)'
            // });
            // stageFlicker();


          once = false;
      }




      function randomIntFromInterval(min,max){
          return Math.random()*(max-min+1)+min;
      }
      function fadeTween(object, speed, opacity, delay) {
        window.TweenMax.to(object, speed, {
            // opacity: opacity,
            attr: {
                opacity: opacity
            },
            delay: delay,
            repeat: -1,
            yoyo: true
        });
      }
      function flicker(object, speed, opacity) {
          window.TweenMax.to(object, speed, {
              opacity: opacity,
              ease: window.RoughEase.ease.config({ template:  window.Power0.easeNone, strength: 0.75, points: 20, taper: "none", randomize:  true, clamp: true}),
              repeat: -1,
              yoyo: true
          });
      }
      function stageFlicker() {
          window.TweenMax.to(lightingSwatch, 8, {
              color: 'rgba(0, 120, 24, 0.3)',
              backgroundColor: 'rgba(0, 0, 0, 0.85)',
              repeat: -1,
              yoyo: true,
              ease: window.RoughEase.ease.config({ template:  window.Power0.easeNone, strength: 0.7, points: 25, taper: "none", randomize:  true, clamp: true}),
              onUpdate: function() {
                  var highlightColor = getComputedStyle(lightingSwatch, null ).color;
                  var shadowColor = getComputedStyle(lightingSwatch, null ).backgroundColor;

                  window.TweenMax.set(stageLight, {
                      'background-image': "radial-gradient(circle farthest-corner at 70% 50%, " + highlightColor + " 0%, " + shadowColor + " 100%)"
                  });
              }
          });
      }

  }

  render(){

    const wreathClass = classNames({
      'wreath__card': this.props.view === 'questions',
      'wreath__tickets': this.props.view === 'intro'
    });

    const image = {
      x: (this.props.view === 'intro') ? '195.1' : '187.681' ,
      y: (this.props.view === 'intro') ? '190.801' : '182.758' ,
      width: (this.props.view === 'intro') ? '438.194' : '445.88' ,
      height: (this.props.view === 'intro') ? '466.98' : '469.07' ,
      url: (this.props.view === 'intro') ? '../../images/tickets/AllCards.png' : '../../images/card.png',
      clip: (this.props.view === 'intro') ? '#wreath-ticket-clip--top' : '#card-clip--top',
      bulbRed: (this.props.view === 'intro') ? '#bulb__r-fill' : '#bulb__r-fill',
      bulbBlue: (this.props.view === 'intro') ? '#bulb__b-fill' : '#bulb__b-fill',
      bulbGreen: (this.props.view === 'intro') ? '#bulb__g-fill' : '#bulb__g-fill',
      bulbYellow: (this.props.view === 'intro') ? '#bulb__y-fill' : '#bulb__y-fill',
    }

    return (
      <g>
          <g className={wreathClass}>
              <image x={image.x} y={image.y} xlinkHref={image.url} width={image.width} height={image.height} filter="url(#ticket-shadow)" />
          </g>
          <g className="wreath__art">
              <use xlinkHref="#wreath__cord"  width="793.3" height="819.9" y="0" x="0"  overflow="visible"/>
              <use xlinkHref="#bokeh--large"  width="793.3" height="819.9" y="0" x="0"  overflow="visible"/>
              <use xlinkHref="#bokeh--large"  width="793.3" height="819.9" y="0" x="0"  overflow="visible"/>
              <image x="90" y="121.5" width="630" height="613" xlinkHref="../../images/wreath/lights-static.png"/>

              <g className="wreath__bulbs">

                  <g transform="matrix(0.9879 -0.1552 -0.1552 -0.9879 430.1981 168.705)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--red" xlinkHref={image.bulbRed} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>


                  <g transform="matrix(-0.9672 -0.2539 -0.2539 0.9672 369.2804 214.3993)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--green" xlinkHref={image.bulbGreen} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>

                  <g transform="matrix(9.256322e-02 -0.9957 -0.9957 -9.256322e-02 283.6137 198.3993)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--blue" xlinkHref={image.bulbBlue} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>

                  <g transform="matrix(-0.7118 -0.7024 -0.7024 0.7118 253.6138 258.7326)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--green" xlinkHref={image.bulbYellow} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>

                  <g transform="matrix(-0.1846 -0.9828 -0.9828 0.1846 187.9471 290.3993)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--red" xlinkHref={image.bulbRed} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>

                  <g transform="matrix(-0.9966 8.227554e-02 8.227554e-02 0.9966 194.9471 361.3993)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--green" xlinkHref={image.bulbGreen} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>

                  <g transform="matrix(-0.1021 -0.9948 -0.9948 0.1021 136.9471 410.3993)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--blue" xlinkHref={image.bulbBlue} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>

                  <g transform="matrix(-0.9994 3.417527e-02 3.417527e-02 0.9994 170.9471 482.3993)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--yellow" xlinkHref={image.bulbYellow} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>

                  <g transform="matrix(-0.9298 -0.368 -0.368 0.9298 165.9471 555.7326)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--red" xlinkHref={image.bulbRed} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>

                  <g transform="matrix(-0.7583 0.6519 0.6519 0.7583 227.6138 595.066)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--green" xlinkHref={image.bulbGreen} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>

                  <g transform="matrix(-0.809 0.5877 0.5877 0.809 273.9471 646.7326)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--blue" xlinkHref={image.bulbBlue} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>

                  <g transform="matrix(-0.6946 0.7194 0.7194 0.6946 338.2804 679.3993)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--yellow" xlinkHref={image.bulbYellow} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>

                  <g transform="matrix(0.7263 0.6873 0.6873 -0.7263 398.6137 660.3993)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--red" xlinkHref={image.bulbRed} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>

                  <g transform="matrix(-0.4113 0.9115 0.9115 0.4113 466.6137 687.3993)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--green" xlinkHref={image.bulbGreen} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>

                  <g transform="matrix(0.6245 0.7811 0.7811 -0.6245 514.6138 638.066)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--blue" xlinkHref={image.bulbBlue} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>

                  <g transform="matrix(0.1879 0.9822 0.9822 -0.1879 600.9471 625.066)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--yellow" xlinkHref={image.bulbYellow} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>

                  <g transform="matrix(0.8373 -0.5468 -0.5468 -0.8373 602.6138 550.7326)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--red" xlinkHref={image.bulbRed} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>

                  <g transform="matrix(-8.769031e-02 0.9961 0.9961 8.769031e-02 672.6138 539.3993)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--green" xlinkHref={image.bulbGreen} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>

                  <g transform="matrix(0.8319 -0.5549 -0.5549 -0.8319 643.9471 465.0659)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--blue" xlinkHref={image.bulbBlue} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>
                  <g transform="matrix(0.7339 0.6792 0.6792 -0.7339 665.859 404.3975)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--yellow" xlinkHref={image.bulbYellow} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>
                  <g transform="matrix(1 0 0 -1 620.1265 275.0658)" style={overflowVisible}>
                    <use ref="bulb" className="js-bulb js-bulb--green" xlinkHref={image.bulbGreen} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>
                  <g transform="matrix(1 0 0 -1 571.047 219.803)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--blue" xlinkHref={image.bulbBlue} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>
                  <g transform="matrix(-0.2568 -0.9665 -0.9665 0.2568 493.9471 214.7326)" style={overflowVisible}>
                          <use ref="bulb" className="js-bulb js-bulb--yellow" xlinkHref={image.bulbYellow} width="94" height="94" x="-47" y="-47" style={overflowVisible} />
                  </g>
              </g>

              <image x="90" y="121.5" width="630" height="613" xlinkHref="../../images/wreath/light-glasses.png"/>
              <image x="90" y="121.5" width="630" height="613" xlinkHref="../../images/wreath/light-glasses.png"/>
              <g className="wreath__bokah--small">
                  <use xlinkHref="#bokah--small"  width="763.7" height="652.4" y="-652.4" transform="matrix(1 0 0 -1 0 109.4148)" overflow="visible"/>
                  <use xlinkHref="#bokah--small"  width="763.7" height="652.4" y="-652.4" transform="matrix(1 0 0 -1 0 109.4148)" overflow="visible"/>
                  <use xlinkHref="#bokah--small"  width="763.7" height="652.4" y="-652.4" transform="matrix(1 0 0 -1 0 109.4148)" overflow="visible"/>
              </g>
          </g>
          <g className={wreathClass}>
              <image x={image.x} y={image.y} xlinkHref={image.url} width={image.width} height={image.height}  clipPath={`url(${image.clip})`} />
          </g>
        </g>
    );
  }
}

export default Wreath;



/** WEBPACK FOOTER **
 ** ./src/components/Scenes/Wreath/Wreath.js
 **/